import React from 'react'
import Swal from 'sweetalert2';
import { Link } from "react-router-dom";
import authAxios from "../../services/Token";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAt, faHashtag, faEdit, faTimes } from '@fortawesome/free-solid-svg-icons';

class Editar extends React.Component {
    constructor(props) {
        super(props);
    }
    state = {
        load: '',
        doctores: [],
        errors: []
    }
    changeValue = (e) => {
        const state = this.state.doctores;
        state[e.target.name] = e.target.value;
        this.setState({ doctores: state });
    };
    errorVerify(elemento) {
        return this.state.errors.indexOf(elemento) !== -1;
    }
    sendData = (e) => {
        e.preventDefault();
        const tipo_identificacion = document.getElementById('tipo_identificacion').value;
        const identificacion = document.getElementById('identificacion').value;
        const nombre = document.getElementById('nombre').value;
        const estado = document.getElementById('estado').value;
        const celular = document.getElementById('celular').value;
        const especialidad = document.getElementById('especialidad').value;
        var errors = [];
        if (!tipo_identificacion) { errors.push("error_tipo_identificacion"); }
        if (!identificacion) { errors.push("error_identificacion"); }
        if (!nombre) { errors.push("error_nombre"); }
        if (!estado) { errors.push("error_estado"); }
        if (!celular) { errors.push("error_celular"); }
        if (!especialidad) { errors.push("error_especialidad"); }
        this.setState({ errors: errors });
        if (errors.length > 0) {
            return false;
        }
        let form = document.getElementById('form');
        let formData = new FormData(form);
        console.log(formData);
        Swal.showLoading();
        authAxios.post("doctores/update", formData)
            .then((dataResult) => {
                console.log(dataResult)
                Swal.close();
                Swal.fire(
                    'Doctores!',
                    dataResult.data.message,
                    'success'
                )
                this.props.history.push("/MasterDoctores");
            })
            .catch(console.log)
    }
    componentDidMount() {
        Swal.showLoading();
        authAxios.get("doctores/view/" + this.props.match.params.id)
            .then((dataResult) => {
                console.log(dataResult);
                this.setState({ doctores: dataResult.data.doctor, load: '' });
                Swal.close();
            })
            .catch(console.log);
    }
    render() {
        const { load, doctores } = this.state;
        return (
            <div className="content-wrapper">
                <div className="content">
                    <div className="container-fluid">
                        <br />
                        <div className="card">
                            <div className="card-header text-center">
                                {load ? (<b>{load}</b>) : (<b>EDITAR DOCTOR</b>)}
                            </div>
                            <div className="card-body">
                                <form onSubmit={this.sendData} id="form">
                                    <div className="row">
                                        <div className="col-xl-12">
                                            <hr style={{ marginBottom: 0, marginTop: 0 }} />
                                            <div style={{ fontSize: 14 }} className="card-header text-center">
                                                <b>INFORMACIÓN DEL DOCTOR</b>
                                            </div>
                                            <div style={{ marginTop: 0 }} className='row g-3'>
                                                <div className="col-md-2">
                                                    <input type="hidden" name="id_doctor" value={this.props.match.params.id} />
                                                    <input type="hidden" name="id_usuario" id="id_usuario" value={window.localStorage.getItem('idusuario')} />
                                                    <label htmlFor="tipo_identificacion">T. Identificación</label>
                                                    <select name="TIPO_IDENTIFICACION"
                                                        id="tipo_identificacion"
                                                        value={doctores.TIPO_IDENTIFICACION}
                                                        options={doctores.TIPO_IDENTIFICACION}
                                                        className={((this.errorVerify("error_tipo_identificacion")) ? "is-invalid" : "") + " form-select form-select-sm"}
                                                        onChange={this.changeValue}>
                                                        <option value="">Seleccione el T.I.</option>
                                                        <option value="1">C.C.</option>
                                                        <option value="2">C.E.</option>
                                                        <option value="3">R.C.</option>
                                                        <option value="4">T.I.</option>
                                                        <option value="5">RUT</option>
                                                    </select>
                                                    <small id="helpId" className="invalid-feedback">Seleccione el T. Identificación</small>
                                                </div>
                                                <div className="col-md-2">
                                                    <label htmlFor="identificacion">Identificación</label>
                                                    <div className={((this.errorVerify("error_identificacion")) ? "is-invalid" : "") + " input-group input-group-sm"}>
                                                        <span className="input-group-text" id="inputGroupPrepend"><FontAwesomeIcon icon={faHashtag} /></span>
                                                        <input type="text" name="identificacion" id="identificacion" defaultValue={doctores.IDENTIFICACION}
                                                            className={((this.errorVerify("error_identificacion")) ? "is-invalid" : "") + " form-control form-control-sm"} maxLength={20}
                                                            placeholder="IDENTIFICACIÓN" aria-describedby="helpId" onChange={this.changeValue} />
                                                    </div>
                                                    <small id="helpId" className="invalid-feedback">Digite la Identificación</small>
                                                </div>
                                                <div className="col-md-3">
                                                    <label htmlFor="nombre">Nombre</label>
                                                    <input style={{ textTransform: 'uppercase' }} type="text" name="nombre" id="nombre" defaultValue={doctores.NOMBRE}
                                                        className={((this.errorVerify("error_nombre")) ? "is-invalid" : "") + " form-control form-control-sm"}
                                                        placeholder="Nombre" aria-describedby="helpId" onChange={this.changeValue} />
                                                    <small id="helpId" className="invalid-feedback">Digite el Nombre</small>
                                                </div>
                                                <div className="col-md-2">
                                                    <label htmlFor="estado">Estado</label>
                                                    <select name="ESTADO"
                                                        id="estado"
                                                        value={doctores.ESTADO}
                                                        options={doctores.ESTADO}
                                                        className={((this.errorVerify("error_estado")) ? "is-invalid" : "") + " form-select form-select-sm"}
                                                        onChange={this.changeValue}>
                                                        <option value="">Seleccione el Estado</option>
                                                        <option value="0">ACTIVO</option>
                                                        <option value="1">INACTIVO</option>
                                                    </select>
                                                    <small id="helpId" className="invalid-feedback">Seleccione el Estado</small>
                                                </div>
                                            </div>
                                            <div style={{ marginTop: 0 }} className='row g-3'>
                                                <div className="col-md-4">
                                                    <label htmlFor="especialidad">Especialidad</label>
                                                    <input style={{ textTransform: 'uppercase' }} type="text" name="especialidad" id="especialidad" defaultValue={doctores.ESPECIALIDAD}
                                                        className={((this.errorVerify("error_especialidad")) ? "is-invalid" : "") + " form-control form-control-sm"}
                                                        placeholder="Especialidad" aria-describedby="helpId" onChange={this.changeValue} />
                                                    <small id="helpId" className="invalid-feedback">Digite la Especialidad</small>
                                                </div>
                                                <div className="col-md-3">
                                                    <label htmlFor="correo_electronico">Correo Electrónico</label>
                                                    <div className="input-group input-group-sm">
                                                        <span className="input-group-text" id="inputGroupPrepend"><FontAwesomeIcon icon={faAt} /></span>
                                                        <input style={{ textTransform: 'lowercase' }} type="text" name="correo_electronico" id="correo_electronico" defaultValue={doctores.EMAIL}
                                                            className="form-control form-control-sm"
                                                            placeholder="ejemplo@dominio.com" aria-describedby="helpId" onChange={this.changeValue} />
                                                    </div>
                                                    <small id="helpId" className="invalid-feedback">Digite el Correo Electrónico</small>
                                                </div>
                                                <div className="col-md-2">
                                                    <label htmlFor="celular">Celular</label>
                                                    <div className={((this.errorVerify("error_celular")) ? "is-invalid" : "") + " input-group input-group-sm"}>
                                                        <span className="input-group-text" id="inputGroupPrepend"><FontAwesomeIcon icon={faHashtag} /></span>
                                                        <input style={{ textTransform: 'uppercase' }} type="text" name="celular" id="celular" defaultValue={doctores.CELULAR}
                                                            className={((this.errorVerify("error_celular")) ? "is-invalid" : "") + " form-control form-control-sm"}
                                                            placeholder="Celular" aria-describedby="helpId" onChange={this.changeValue} />
                                                    </div>
                                                    <small id="helpId" className="invalid-feedback">Digite el Celular</small>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <hr />
                                    <div className='row'>
                                        <div className='col-xl-12 text-center'>
                                            <div className="btn-group" role="group" aria-label="">
                                                <button type="submit" className="btn btn-primary btn-sm"><FontAwesomeIcon icon={faEdit} />&nbsp;&nbsp;Editar</button>&nbsp;&nbsp;
                                                <Link className="btn btn-danger btn-sm" to={"/MasterDoctores"}><FontAwesomeIcon icon={faTimes} />&nbsp;&nbsp;Cancelar</Link>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default Editar;